export default (value) => value;
